import type { AuthenticateBrowserSessionPayload } from '~/composables/api/internal/browser-session/useFetchBrowserSession'
import type { AuthenticateBuilderSessionPayload, BuilderSessionData } from '~/composables/api/internal/builder-session/useFetchBuilderSession'

import { BUILDER_SESSION } from '~/types'

export const useBuilderSessionStore = defineStore('builderSession', () => {
  const {
    checkAuth,
    sessionData,
    authenticateSession,
    isAuthenticated,
    authenticationRequestError,
    cancelSession,
    fetchCurrentSession,
    redirectToHandler,
  } = useApiSessionManagement<
    BuilderSessionData,
    AuthenticateBuilderSessionPayload & AuthenticateBrowserSessionPayload
  >(BUILDER_SESSION)

  // completion
  const {
    state: finalizationRequestData,
    execute: finalize,
    error: finalizationRequestError,
  } = useMutateBuilderSession.finalize()

  whenever(finalizationRequestError, (error: any) => {
    // If failed with status conflict, try to fetch current session
    // as it is probably already completed
    if (error.response?.status === 409)
      fetchCurrentSession()
  })

  whenever(finalizationRequestData, () => {
    sessionData.value = finalizationRequestData.value!
  })

  const finalizeSession = () => finalize(0, {})

  // refresh participant token
  const {
    state: refreshParticipantTokenRequestData,
    execute: refreshParticipantTokenExecute,
    isLoading: isRefreshingToken,
  } = useMutateBuilderSession.refreshParticipantToken()

  whenever(refreshParticipantTokenRequestData, () => {
    sessionData.value = refreshParticipantTokenRequestData.value!
  })

  const refreshParticipantToken = () => refreshParticipantTokenExecute(0, {})

  return {
    checkAuth,
    sessionData,
    authenticateSession,
    isAuthenticated,
    authenticationRequestError,
    finalizeSession,
    finalizationRequestError,
    cancelSession,
    redirectToHandler,
    refreshParticipantToken,
    isRefreshingToken,
  }
})
